export const AUTH_POST_LOGIN = '/auth/emr/oauth/v2/token'
export const AUTH_POST_LOGOUT = '/auth/logout'
export const AUTH_POST_FORGOT_PASSWORD = '/auth/forgot-password'
export const AUTH_POST_SET_PASSWORD = '/auth/set-password'

export const AUTH_GET_USER_PROFILE = '/company/profile'

export const AUTH_REDIRECTED_URLS = ['', '/', '/auth']
